import { useModal } from '@ebay/nice-modal-react'
import { Link } from '@tanstack/router'
import axios from 'axios'
import { useEffect, useMemo, useState } from 'react'

import useCommonEmblaCarousel from '../../hooks/useCommonEmblaCarousel'
import useDimensions from '../../hooks/useDimensions'
import { useBoundStore } from '../../store/store'
import type { CompetitionObj } from '../../types/game'
import Icon from '../icon'
import { PendingDepositModal } from '../payment-form'
import { ImageContainer, StyledLink } from './sliderStyles'

const CompetitionsSlider = () => {
  const { isDesktop } = useDimensions()
  const pending_bind = useBoundStore(state => state.user.pending_bind)
  const pendingDepositModal = useModal(PendingDepositModal)
  const [competitions, setCompetitions] = useState<CompetitionObj[]>([])
  const [emblaRef] = useCommonEmblaCarousel()

  const fillers = useMemo(() => {
    return isDesktop ? 5 - competitions.length : 2 - competitions.length
  }, [isDesktop, competitions])

  useEffect(() => {
    const controller = new AbortController()
    const signal = controller.signal

    const getCompetitions = async () => {
      try {
        const res = (await (
          await fetch(
            'https://raffle-api.mexplay.mx/home/category-competitions?store_id=2&source=h',
            { signal },
          )
        ).json()) as {
          data: {
            competitions: CompetitionObj[]
          }[]
        }

        if (res.data.length > 0) {
          setCompetitions(res.data[0].competitions)
        }
      } catch (error) {
        if (!axios.isCancel(error)) {
          console.error(error)
        }
      }
    }

    getCompetitions()

    return () => {
      controller.abort()
    }
  }, [])

  return (
    <>
      <div className="embla" ref={emblaRef}>
        <div className="embla__container -ml-2.5 lg:-ml-5">
          {competitions.map((competition, index) => (
            <div
              key={index}
              className="pl-2.5 lg:pl-5 flex-[0_0_50%] lg:flex-[0_0_20%]">
              <ImageContainer>
                <img
                  src={competition.banner_image}
                  style={{ aspectRatio: '1' }}
                  alt="Competition"
                />
                <Link
                  to={
                    +pending_bind === 0 || +pending_bind === 2
                      ? undefined
                      : '/sorteos'
                  }>
                  <StyledLink
                    onClick={() => {
                      if (+pending_bind === 0 || +pending_bind === 2)
                        pendingDepositModal.show()
                    }}>
                    <Icon id="arrow-right" width="12" height="11" fill="#000" />
                  </StyledLink>
                </Link>
              </ImageContainer>
            </div>
          ))}
          {fillers > 0 &&
            Array.from(Array(fillers).keys()).map(key => <div key={key} />)}
        </div>
      </div>
    </>
  )
}

export default CompetitionsSlider
